import { female1, female2, female3, female4, male1, male2, male3, male4, stats1, stats2, stats3, userImage } from "../Assets/images";

export const currentUser = {
    image: userImage,
    name: "Jaxson Maverick",
    email: "jmaverick@gmail.com",
    country: "US",
    state: "Washington",
    city: "Seattle",
    phone: "0000-000-0000000",
    postCode: "98101"
}

export const country = [ 
    {name: "Afghanistan",
     code: "AF"
    }, 
    {name: "land Islands",
     code: "AX"
    }, 
    {name: "Albania",
     code: "AL"
    }, 
    {name: "Algeria",
     code: "DZ"
    }, 
    {name: "American Samoa",
     code: "AS"
    }, 
    {name: "AndorrA",
     code: "AD"
    }, 
    {name: "Angola",
     code: "AO"
    }, 
    {name: "Anguilla",
     code: "AI"
    }, 
    {name: "Antarctica",
     code: "AQ"
    }, 
    {name: "Antigua and Barbuda",
     code: "AG"
    }, 
    {name: "Argentina",
     code: "AR"
    }, 
    {name: "Armenia",
     code: "AM"
    }, 
    {name: "Aruba",
     code: "AW"
    }, 
    {name: "Australia",
     code: "AU"
    }, 
    {name: "Austria",
     code: "AT"
    }, 
    {name: "Azerbaijan",
     code: "AZ"
    }, 
    {name: "Bahamas",
     code: "BS"
    }, 
    {name: "Bahrain",
     code: "BH"
    }, 
    {name: "Bangladesh",
     code: "BD"
    }, 
    {name: "Barbados",
     code: "BB"
    }, 
    {name: "Belarus",
     code: "BY"
    }, 
    {name: "Belgium",
     code: "BE"
    }, 
    {name: "Belize",
     code: "BZ"
    }, 
    {name: "Benin",
     code: "BJ"
    }, 
    {name: "Bermuda",
     code: "BM"
    }, 
    {name: "Bhutan",
     code: "BT"
    }, 
    {name: "Bolivia",
     code: "BO"
    }, 
    {name: "Bosnia and Herzegovina",
     code: "BA"
    }, 
    {name: "Botswana",
     code: "BW"
    }, 
    {name: "Bouvet Island",
     code: "BV"
    }, 
    {name: "Brazil",
     code: "BR"
    }, 
    {name: "British Indian Ocean Territory",
     code: "IO"
    }, 
    {name: "Brunei Darussalam",
     code: "BN"
    }, 
    {name: "Bulgaria",
     code: "BG"
    }, 
    {name: "Burkina Faso",
     code: "BF"
    }, 
    {name: "Burundi",
     code: "BI"
    }, 
    {name: "Cambodia",
     code: "KH"
    }, 
    {name: "Cameroon",
     code: "CM"
    }, 
    {name: "Canada",
     code: "CA"
    }, 
    {name: "Cape Verde",
     code: "CV"
    }, 
    {name: "Cayman Islands",
     code: "KY"
    }, 
    {name: "Central African Republic",
     code: "CF"
    }, 
    {name: "Chad",
     code: "TD"
    }, 
    {name: "Chile",
     code: "CL"
    }, 
    {name: "China",
     code: "CN"
    }, 
    {name: "Christmas Island",
     code: "CX"
    }, 
    {name: "Cocos (Keeling) Islands",
     code: "CC"
    }, 
    {name: "Colombia",
     code: "CO"
    }, 
    {name: "Comoros",
     code: "KM"
    }, 
    {name: "Congo",
     code: "CG"
    }, 
    {name: "Congo, The Democratic Republic of the",
     code: "CD"
    }, 
    {name: "Cook Islands",
     code: "CK"
    }, 
    {name: "Costa Rica",
     code: "CR"
    }, 
    {name: "Cote D Ivoire",
     code: "CI"
    }, 
    {name: "Croatia",
     code: "HR"
    }, 
    {name: "Cuba",
     code: "CU"
    }, 
    {name: "Cyprus",
     code: "CY"
    }, 
    {name: "Czech Republic",
     code: "CZ"
    }, 
    {name: "Denmark",
     code: "DK"
    }, 
    {name: "Djibouti",
     code: "DJ"
    }, 
    {name: "Dominica",
     code: "DM"
    }, 
    {name: "Dominican Republic",
     code: "DO"
    }, 
    {name: "Ecuador",
     code: "EC"
    }, 
    {name: "Egypt",
     code: "EG"
    }, 
    {name: "El Salvador",
     code: "SV"
    }, 
    {name: "Equatorial Guinea",
     code: "GQ"
    }, 
    {name: "Eritrea",
     code: "ER"
    }, 
    {name: "Estonia",
     code: "EE"
    }, 
    {name: "Ethiopia",
     code: "ET"
    }, 
    {name: "Falkland Islands (Malvinas)",
     code: "FK"
    }, 
    {name: "Faroe Islands",
     code: "FO"
    }, 
    {name: "Fiji",
     code: "FJ"
    }, 
    {name: "Finland",
     code: "FI"
    }, 
    {name: "France",
     code: "FR"
    }, 
    {name: "French Guiana",
     code: "GF"
    }, 
    {name: "French Polynesia",
     code: "PF"
    }, 
    {name: "French Southern Territories",
     code: "TF"
    }, 
    {name: "Gabon",
     code: "GA"
    }, 
    {name: "Gambia",
     code: "GM"
    }, 
    {name: "Georgia",
     code: "GE"
    }, 
    {name: "Germany",
     code: "DE"
    }, 
    {name: "Ghana",
     code: "GH"
    }, 
    {name: "Gibraltar",
     code: "GI"
    }, 
    {name: "Greece",
     code: "GR"
    }, 
    {name: "Greenland",
     code: "GL"
    }, 
    {name: "Grenada",
     code: "GD"
    }, 
    {name: "Guadeloupe",
     code: "GP"
    }, 
    {name: "Guam",
     code: "GU"
    }, 
    {name: "Guatemala",
     code: "GT"
    }, 
    {name: "Guernsey",
     code: "GG"
    }, 
    {name: "Guinea",
     code: "GN"
    }, 
    {name: "Guinea-Bissau",
     code: "GW"
    }, 
    {name: "Guyana",
     code: "GY"
    }, 
    {name: "Haiti",
     code: "HT"
    }, 
    {name: "Heard Island and Mcdonald Islands",
     code: "HM"
    }, 
    {name: "Holy See (Vatican City State)",
     code: "VA"
    }, 
    {name: "Honduras",
     code: "HN"
    }, 
    {name: "Hong Kong",
     code: "HK"
    }, 
    {name: "Hungary",
     code: "HU"
    }, 
    {name: "Iceland",
     code: "IS"
    }, 
    {name: "India",
     code: "IN"
    }, 
    {name: "Indonesia",
     code: "ID"
    }, 
    {name: "Iran, Islamic Republic Of",
     code: "IR"
    }, 
    {name: "Iraq",
     code: "IQ"
    }, 
    {name: "Ireland",
     code: "IE"
    }, 
    {name: "Isle of Man",
     code: "IM"
    }, 
    {name: "Israel",
     code: "IL"
    }, 
    {name: "Italy",
     code: "IT"
    }, 
    {name: "Jamaica",
     code: "JM"
    }, 
    {name: "Japan",
     code: "JP"
    }, 
    {name: "Jersey",
     code: "JE"
    }, 
    {name: "Jordan",
     code: "JO"
    }, 
    {name: "Kazakhstan",
     code: "KZ"
    }, 
    {name: "Kenya",
     code: "KE"
    }, 
    {name: "Kiribati",
     code: "KI"
    }, 
    {name: "Korea, Democratic People S Republic of",
     code: "KP"
    }, 
    {name: "Korea, Republic of",
     code: "KR"
    }, 
    {name: "Kuwait",
     code: "KW"
    }, 
    {name: "Kyrgyzstan",
     code: "KG"
    }, 
    {name: "Lao People S Democratic Republic",
     code: "LA"
    }, 
    {name: "Latvia",
     code: "LV"
    }, 
    {name: "Lebanon",
     code: "LB"
    }, 
    {name: "Lesotho",
     code: "LS"
    }, 
    {name: "Liberia",
     code: "LR"
    }, 
    {name: "Libyan Arab Jamahiriya",
     code: "LY"
    }, 
    {name: "Liechtenstein",
     code: "LI"
    }, 
    {name: "Lithuania",
     code: "LT"
    }, 
    {name: "Luxembourg",
     code: "LU"
    }, 
    {name: "Macao",
     code: "MO"
    }, 
    {name: "Macedonia, The Former Yugoslav Republic of",
     code: "MK"
    }, 
    {name: "Madagascar",
     code: "MG"
    }, 
    {name: "Malawi",
     code: "MW"
    }, 
    {name: "Malaysia",
     code: "MY"
    }, 
    {name: "Maldives",
     code: "MV"
    }, 
    {name: "Mali",
     code: "ML"
    }, 
    {name: "Malta",
     code: "MT"
    }, 
    {name: "Marshall Islands",
     code: "MH"
    }, 
    {name: "Martinique",
     code: "MQ"
    }, 
    {name: "Mauritania",
     code: "MR"
    }, 
    {name: "Mauritius",
     code: "MU"
    }, 
    {name: "Mayotte",
     code: "YT"
    }, 
    {name: "Mexico",
     code: "MX"
    }, 
    {name: "Micronesia, Federated States of",
     code: "FM"
    }, 
    {name: "Moldova, Republic of",
     code: "MD"
    }, 
    {name: "Monaco",
     code: "MC"
    }, 
    {name: "Mongolia",
     code: "MN"
    }, 
    {name: "Montenegro",
     code: "ME"
    },
    {name: "Montserrat",
     code: "MS"
    },
    {name: "Morocco",
     code: "MA"
    }, 
    {name: "Mozambique",
     code: "MZ"
    }, 
    {name: "Myanmar",
     code: "MM"
    }, 
    {name: "Namibia",
     code: "NA"
    }, 
    {name: "Nauru",
     code: "NR"
    }, 
    {name: "Nepal",
     code: "NP"
    }, 
    {name: "Netherlands",
     code: "NL"
    }, 
    {name: "Netherlands Antilles",
     code: "AN"
    }, 
    {name: "New Caledonia",
     code: "NC"
    }, 
    {name: "New Zealand",
     code: "NZ"
    }, 
    {name: "Nicaragua",
     code: "NI"
    }, 
    {name: "Niger",
     code: "NE"
    }, 
    {name: "Nigeria",
     code: "NG"
    }, 
    {name: "Niue",
     code: "NU"
    }, 
    {name: "Norfolk Island",
     code: "NF"
    }, 
    {name: "Northern Mariana Islands",
     code: "MP"
    }, 
    {name: "Norway",
     code: "NO"
    }, 
    {name: "Oman",
     code: "OM"
    }, 
    {name: "Pakistan",
     code: "PK"
    }, 
    {name: "Palau",
     code: "PW"
    }, 
    {name: "Palestinian Territory, Occupied",
     code: "PS"
    }, 
    {name: "Panama",
     code: "PA"
    }, 
    {name: "Papua New Guinea",
     code: "PG"
    }, 
    {name: "Paraguay",
     code: "PY"
    }, 
    {name: "Peru",
     code: "PE"
    }, 
    {name: "Philippines",
     code: "PH"
    }, 
    {name: "Pitcairn",
     code: "PN"
    }, 
    {name: "Poland",
     code: "PL"
    }, 
    {name: "Portugal",
     code: "PT"
    }, 
    {name: "Puerto Rico",
     code: "PR"
    }, 
    {name: "Qatar",
     code: "QA"
    }, 
    {name: "Reunion",
     code: "RE"
    }, 
    {name: "Romania",
     code: "RO"
    }, 
    {name: "Russian Federation",
     code: "RU"
    }, 
    {name: "RWANDA",
     code: "RW"
    }, 
    {name: "Saint Helena",
     code: "SH"
    }, 
    {name: "Saint Kitts and Nevis",
     code: "KN"
    }, 
    {name: "Saint Lucia",
     code: "LC"
    }, 
    {name: "Saint Pierre and Miquelon",
     code: "PM"
    }, 
    {name: "Saint Vincent and the Grenadines",
     code: "VC"
    }, 
    {name: "Samoa",
     code: "WS"
    }, 
    {name: "San Marino",
     code: "SM"
    }, 
    {name: "Sao Tome and Principe",
     code: "ST"
    }, 
    {name: "Saudi Arabia",
     code: "SA"
    }, 
    {name: "Senegal",
     code: "SN"
    }, 
    {name: "Serbia",
     code: "RS"
    }, 
    {name: "Seychelles",
     code: "SC"
    }, 
    {name: "Sierra Leone",
     code: "SL"
    }, 
    {name: "Singapore",
     code: "SG"
    }, 
    {name: "Slovakia",
     code: "SK"
    }, 
    {name: "Slovenia",
     code: "SI"
    }, 
    {name: "Solomon Islands",
     code: "SB"
    }, 
    {name: "Somalia",
     code: "SO"
    }, 
    {name: "South Africa",
     code: "ZA"
    }, 
    {name: "South Georgia and the South Sandwich Islands",
     code: "GS"
    }, 
    {name: "Spain",
     code: "ES"
    }, 
    {name: "Sri Lanka",
     code: "LK"
    }, 
    {name: "Sudan",
     code: "SD"
    }, 
    {name: "Suriname",
     code: "SR"
    }, 
    {name: "Svalbard and Jan Mayen",
     code: "SJ"
    }, 
    {name: "Swaziland",
     code: "SZ"
    }, 
    {name: "Sweden",
     code: "SE"
    }, 
    {name: "Switzerland",
     code: "CH"
    }, 
    {name: "Syrian Arab Republic",
     code: "SY"
    }, 
    {name: "Taiwan, Province of China",
     code: "TW"
    }, 
    {name: "Tajikistan",
     code: "TJ"
    }, 
    {name: "Tanzania, United Republic of",
     code: "TZ"
    }, 
    {name: "Thailand",
     code: "TH"
    }, 
    {name: "Timor-Leste",
     code: "TL"
    }, 
    {name: "Togo",
     code: "TG"
    }, 
    {name: "Tokelau",
     code: "TK"
    }, 
    {name: "Tonga",
     code: "TO"
    }, 
    {name: "Trinidad and Tobago",
     code: "TT"
    }, 
    {name: "Tunisia",
     code: "TN"
    }, 
    {name: "Turkey",
     code: "TR"
    }, 
    {name: "Turkmenistan",
     code: "TM"
    }, 
    {name: "Turks and Caicos Islands",
     code: "TC"
    }, 
    {name: "Tuvalu",
     code: "TV"
    }, 
    {name: "Uganda",
     code: "UG"
    }, 
    {name: "Ukraine",
     code: "UA"
    }, 
    {name: "United Arab Emirates",
     code: "AE"
    }, 
    {name: "United Kingdom",
     code: "GB"
    }, 
    {name: "United States",
     code: "US"
    }, 
    {name: "United States Minor Outlying Islands",
     code: "UM"
    }, 
    {name: "Uruguay",
     code: "UY"
    }, 
    {name: "Uzbekistan",
     code: "UZ"
    }, 
    {name: "Vanuatu",
     code: "VU"
    }, 
    {name: "Venezuela",
     code: "VE"
    }, 
    {name: "Viet Nam",
     code: "VN"
    }, 
    {name: "Virgin Islands, British",
     code: "VG"
    }, 
    {name: "Virgin Islands, U.S.",
     code: "VI"
    }, 
    {name: "Wallis and Futuna",
     code: "WF"
    }, 
    {name: "Western Sahara",
     code: "EH"
    }, 
    {name: "Yemen",
     code: "YE"
    }, 
    {name: "Zambia",
     code: "ZM"
    }, 
    {name: "Zimbabwe",
     code: "ZW"} 
    ]

export const stats = [
    {
        id: 1,
        image: stats1,
        number: "100",
        subData: "Since last week",
        text: "Total Brands",
        change: "100",
        increase: true,
    },
    {
        id: 2,
        image: stats2,
        subData: "Since last week",
        number: "22",
        text: "Total Sales",
        change: "100",
        increase: true,
    },
    {
        id: 3,
        image: stats3,
        subData: "Since last week",
        number: "22",
        text: "Total Units",
        change: "100",
        increase: false,
    },
]

export const userData = [
    {
        id: 1,
        status: true,
        image: male1,
        gender: "Male",
        name: "John Doe",
        username: "john.doe",
        email: "john@email.com",
        phone: "+1-123-456-789",
        registered: "08/10/2022",
        age: "25",
        location: "Abc address",
        about:
            "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
        interest: ["Swimming", "Movies", "Nightout"],
    },
    {
        id: 2,
        status: true,
        image: male2,
        gender: "Male",
        name: "Mark Jason",
        username: "mark.jason",
        email: "mark@email.com",
        phone: "+1-321-666-789",
        registered: "02/10/2022",
        age: "24",
        location: "Xyz address",
        about:
            "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing.",
        interest: ["Reading", "Movies", "Painting"],
    },
    {
        id: 3,
        status: false,
        image: male3,
        gender: "Male",
        name: "Mike Roy",
        username: "mike.roy",
        email: "mikeroy@email.com",
        phone: "+1-525-864-125",
        registered: "26/09/2022",
        age: "27",
        location: "Abc street address",
        about:
            "simply dummy text of printing & typesetting industry of printing & typesetting industry.",
        interest: ["Football", "Rafting", "Nightout"],
    },
    {
        id: 4,
        status: true,
        image: male4,
        gender: "Male",
        name: "Will Byers",
        username: "byers.will",
        email: "will@email.com",
        phone: "+1-985-999-625",
        registered: "22/09/2022",
        age: "19",
        location: "Xyz address",
        about:
            "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
        interest: ["Painting", "Writing", "Gaming"],
    },
    {
        id: 5,
        status: false,
        image: male2,
        gender: "Male",
        name: "Isidro Haris",
        username: "isidro",
        email: "isidro@email.com",
        phone: "+1-206-396-1973",
        registered: "22/09/2022",
        age: "31",
        location: "Abc address",
        about:
            "Lorem Ipsum is text of printing & typesetting industry of printing & typesetting industry.",
        interest: ["Shooting", "Baseball", "Boxing"],
    },
    {
        id: 6,
        status: true,
        image: male3,
        gender: "Male",
        name: "James Doe",
        username: "james.doe",
        email: "james.doe@email.com",
        phone: "+1-984-456-987",
        registered: "18/09/2022",
        age: "20",
        location: "Abc address",
        about:
            "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
        interest: ["Swimming", "Gaming", "Movies", "Surfing"],
    },
    {
        id: 7,
        status: true,
        image: male1,
        gender: "Male",
        name: "John Doe",
        username: "john.doe",
        email: "john@email.com",
        phone: "+1-123-456-789",
        registered: "08/10/2022",
        age: "25",
        location: "Abc address",
        about:
            "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
        interest: ["Swimming", "Movies", "Nightout"],
    },
    {
        id: 8,
        status: true,
        image: male2,
        gender: "Male",
        name: "Mark Jason",
        username: "mark.jason",
        email: "mark@email.com",
        phone: "+1-321-666-789",
        registered: "02/10/2022",
        age: "24",
        location: "Xyz address",
        about:
            "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing.",
        interest: ["Reading", "Movies", "Painting"],
    },
    {
        id: 9,
        status: false,
        image: male3,
        gender: "Male",
        name: "Mike Roy",
        username: "mike.roy",
        email: "mikeroy@email.com",
        phone: "+1-525-864-125",
        registered: "26/09/2022",
        age: "27",
        location: "Abc street address",
        about:
            "simply dummy text of printing & typesetting industry of printing & typesetting industry.",
        interest: ["Football", "Rafting", "Nightout"],
    },
    {
        id: 10,
        status: true,
        image: male4,
        gender: "Male",
        name: "Will Byers",
        username: "byers.will",
        email: "will@email.com",
        phone: "+1-985-999-625",
        registered: "22/09/2022",
        age: "19",
        location: "Xyz address",
        about:
            "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
        interest: ["Painting", "Writing", "Gaming"],
    },
    {
        id: 11,
        status: false,
        image: male2,
        gender: "Male",
        name: "Isidro Haris",
        username: "isidro",
        email: "isidro@email.com",
        phone: "+1-206-396-1973",
        registered: "22/09/2022",
        age: "31",
        location: "Abc address",
        about:
            "Lorem Ipsum is text of printing & typesetting industry of printing & typesetting industry.",
        interest: ["Shooting", "Baseball", "Boxing"],
    },
    {
        id: 12,
        status: true,
        image: male3,
        gender: "Male",
        name: "James Doe",
        username: "james.doe",
        email: "james.doe@email.com",
        phone: "+1-984-456-987",
        registered: "18/09/2022",
        age: "20",
        location: "Abc address",
        about:
            "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
        interest: ["Swimming", "Gaming", "Movies", "Surfing"],
    },
    {
    id: 1,
        status: true,
        image: male1,
        gender: "Male",
        name: "John Doe",
        username: "john.doe",
        email: "john@email.com",
        phone: "+1-123-456-789",
        registered: "08/10/2022",
        age: "25",
        location: "Abc address",
        about:
            "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
        interest: ["Swimming", "Movies", "Nightout"],
    },
    {
        id: 2,
        status: true,
        image: male2,
        gender: "Male",
        name: "Mark Jason",
        username: "mark.jason",
        email: "mark@email.com",
        phone: "+1-321-666-789",
        registered: "02/10/2022",
        age: "24",
        location: "Xyz address",
        about:
            "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing.",
        interest: ["Reading", "Movies", "Painting"],
    },
    {
        id: 3,
        status: false,
        image: male3,
        gender: "Male",
        name: "Mike Roy",
        username: "mike.roy",
        email: "mikeroy@email.com",
        phone: "+1-525-864-125",
        registered: "26/09/2022",
        age: "27",
        location: "Abc street address",
        about:
            "simply dummy text of printing & typesetting industry of printing & typesetting industry.",
        interest: ["Football", "Rafting", "Nightout"],
    },
    {
        id: 4,
        status: true,
        image: male4,
        gender: "Male",
        name: "Will Byers",
        username: "byers.will",
        email: "will@email.com",
        phone: "+1-985-999-625",
        registered: "22/09/2022",
        age: "19",
        location: "Xyz address",
        about:
            "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
        interest: ["Painting", "Writing", "Gaming"],
    },
    {
        id: 5,
        status: false,
        image: male2,
        gender: "Male",
        name: "Isidro Haris",
        username: "isidro",
        email: "isidro@email.com",
        phone: "+1-206-396-1973",
        registered: "22/09/2022",
        age: "31",
        location: "Abc address",
        about:
            "Lorem Ipsum is text of printing & typesetting industry of printing & typesetting industry.",
        interest: ["Shooting", "Baseball", "Boxing"],
    },
    {
        id: 6,
        status: true,
        image: male3,
        gender: "Male",
        name: "James Doe",
        username: "james.doe",
        email: "james.doe@email.com",
        phone: "+1-984-456-987",
        registered: "18/09/2022",
        age: "20",
        location: "Abc address",
        about:
            "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
        interest: ["Swimming", "Gaming", "Movies", "Surfing"],
    },
    {
        id: 7,
        status: true,
        image: male1,
        gender: "Male",
        name: "John Doe",
        username: "john.doe",
        email: "john@email.com",
        phone: "+1-123-456-789",
        registered: "08/10/2022",
        age: "25",
        location: "Abc address",
        about:
            "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
        interest: ["Swimming", "Movies", "Nightout"],
    },
    {
        id: 8,
        status: true,
        image: male2,
        gender: "Male",
        name: "Mark Jason",
        username: "mark.jason",
        email: "mark@email.com",
        phone: "+1-321-666-789",
        registered: "02/10/2022",
        age: "24",
        location: "Xyz address",
        about:
            "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing.",
        interest: ["Reading", "Movies", "Painting"],
    },
    {
        id: 9,
        status: false,
        image: male3,
        gender: "Male",
        name: "Mike Roy",
        username: "mike.roy",
        email: "mikeroy@email.com",
        phone: "+1-525-864-125",
        registered: "26/09/2022",
        age: "27",
        location: "Abc street address",
        about:
            "simply dummy text of printing & typesetting industry of printing & typesetting industry.",
        interest: ["Football", "Rafting", "Nightout"],
    },
    {
        id: 10,
        status: true,
        image: male4,
        gender: "Male",
        name: "Will Byers",
        username: "byers.will",
        email: "will@email.com",
        phone: "+1-985-999-625",
        registered: "22/09/2022",
        age: "19",
        location: "Xyz address",
        about:
            "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
        interest: ["Painting", "Writing", "Gaming"],
    },
    {
        id: 11,
        status: false,
        image: male2,
        gender: "Male",
        name: "Isidro Haris",
        username: "isidro",
        email: "isidro@email.com",
        phone: "+1-206-396-1973",
        registered: "22/09/2022",
        age: "31",
        location: "Abc address",
        about:
            "Lorem Ipsum is text of printing & typesetting industry of printing & typesetting industry.",
        interest: ["Shooting", "Baseball", "Boxing"],
    },
    {
        id: 12,
        status: true,
        image: male3,
        gender: "Male",
        name: "James Doe",
        username: "james.doe",
        email: "james.doe@email.com",
        phone: "+1-984-456-987",
        registered: "18/09/2022",
        age: "20",
        location: "Abc address",
        about:
            "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
        interest: ["Swimming", "Gaming", "Movies", "Surfing"],
    },
];

export const maleData = [
    {
        id: 1,
        status: true,
        image: male1,
        gender: "Male",
        name: "John Doe",
        username: "john.doe",
        email: "john@email.com",
        phone: "+1-123-456-789",
        registered: "08/10/2022",
        age: "25",
        location: "Abc address",
        about:
            "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
        interest: ["Swimming", "Movies", "Nightout"],
    },
    {
        id: 2,
        status: true,
        image: male2,
        gender: "Male",
        name: "Mark Jason",
        username: "mark.jason",
        email: "mark@email.com",
        phone: "+1-321-666-789",
        registered: "02/10/2022",
        age: "24",
        location: "Xyz address",
        about:
            "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing.",
        interest: ["Reading", "Movies", "Painting"],
    },
    {
        id: 3,
        status: false,
        image: male3,
        gender: "Male",
        name: "Mike Roy",
        username: "mike.roy",
        email: "mikeroy@email.com",
        phone: "+1-525-864-125",
        registered: "26/09/2022",
        age: "27",
        location: "Abc street address",
        about:
            "simply dummy text of printing & typesetting industry of printing & typesetting industry.",
        interest: ["Football", "Rafting", "Nightout"],
    },
    {
        id: 4,
        status: true,
        image: male4,
        gender: "Male",
        name: "Will Byers",
        username: "byers.will",
        email: "will@email.com",
        phone: "+1-985-999-625",
        registered: "22/09/2022",
        age: "19",
        location: "Xyz address",
        about:
            "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
        interest: ["Painting", "Writing", "Gaming"],
    },
    {
        id: 5,
        status: false,
        image: male2,
        gender: "Male",
        name: "Isidro Haris",
        username: "isidro",
        email: "isidro@email.com",
        phone: "+1-206-396-1973",
        registered: "22/09/2022",
        age: "31",
        location: "Abc address",
        about:
            "Lorem Ipsum is text of printing & typesetting industry of printing & typesetting industry.",
        interest: ["Shooting", "Baseball", "Boxing"],
    },
    {
        id: 6,
        status: true,
        image: male3,
        gender: "Male",
        name: "James Doe",
        username: "james.doe",
        email: "james.doe@email.com",
        phone: "+1-984-456-987",
        registered: "18/09/2022",
        age: "20",
        location: "Abc address",
        about:
            "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
        interest: ["Swimming", "Gaming", "Movies", "Surfing"],
    },
    {
        id: 7,
        status: true,
        image: male1,
        gender: "Male",
        name: "John Doe",
        username: "john.doe",
        email: "john@email.com",
        phone: "+1-123-456-789",
        registered: "08/10/2022",
        age: "25",
        location: "Abc address",
        about:
            "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
        interest: ["Swimming", "Movies", "Nightout"],
    },
    {
        id: 8,
        status: true,
        image: male2,
        gender: "Male",
        name: "Mark Jason",
        username: "mark.jason",
        email: "mark@email.com",
        phone: "+1-321-666-789",
        registered: "02/10/2022",
        age: "24",
        location: "Xyz address",
        about:
            "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing.",
        interest: ["Reading", "Movies", "Painting"],
    },
    {
        id: 9,
        status: false,
        image: male3,
        gender: "Male",
        name: "Mike Roy",
        username: "mike.roy",
        email: "mikeroy@email.com",
        phone: "+1-525-864-125",
        registered: "26/09/2022",
        age: "27",
        location: "Abc street address",
        about:
            "simply dummy text of printing & typesetting industry of printing & typesetting industry.",
        interest: ["Football", "Rafting", "Nightout"],
    },
    {
        id: 10,
        status: true,
        image: male4,
        gender: "Male",
        name: "Will Byers",
        username: "byers.will",
        email: "will@email.com",
        phone: "+1-985-999-625",
        registered: "22/09/2022",
        age: "19",
        location: "Xyz address",
        about:
            "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
        interest: ["Painting", "Writing", "Gaming"],
    },
    {
        id: 11,
        status: false,
        image: male2,
        gender: "Male",
        name: "Isidro Haris",
        username: "isidro",
        email: "isidro@email.com",
        phone: "+1-206-396-1973",
        registered: "22/09/2022",
        age: "31",
        location: "Abc address",
        about:
            "Lorem Ipsum is text of printing & typesetting industry of printing & typesetting industry.",
        interest: ["Shooting", "Baseball", "Boxing"],
    },
    {
        id: 12,
        status: true,
        image: male3,
        gender: "Male",
        name: "James Doe",
        username: "james.doe",
        email: "james.doe@email.com",
        phone: "+1-984-456-987",
        registered: "18/09/2022",
        age: "20",
        location: "Abc address",
        about:
            "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
        interest: ["Swimming", "Gaming", "Movies", "Surfing"],
    },
];

export const femaleData = [
    {
        id: 1,
        status: true,
        image: female1,
        gender: "Female",
        name: "Ogasawara Katsumi",
        username: "ogasawara.katsumi",
        email: "ogasawara@email.com",
        phone: "+1-123-456-789",
        registered: "08/10/2022",
        age: "25",
        location: "Abc address",
        about:
            "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
        interest: ["Swimming", "Movies", "Nightout"],
        price: "20",
        commission: "10",
    },
    {
        id: 2,
        status: true,
        image: female2,
        gender: "Female",
        name: "Stepan Assonov",
        username: "stepan.assonov",
        email: "stepan@email.com",
        phone: "+1-321-666-789",
        registered: "02/10/2022",
        age: "24",
        location: "Xyz address",
        about:
            "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing.",
        interest: ["Reading", "Movies", "Painting"],
        price: "30",
        commission: "20",
    },
    {
        id: 3,
        status: false,
        image: female3,
        gender: "Female",
        name: "Lucas Pacheco",
        username: "lucas.pacheco",
        email: "Lucas@email.com",
        phone: "+1-525-864-125",
        registered: "26/09/2022",
        age: "27",
        location: "Abc street address",
        about:
            "simply dummy text of printing & typesetting industry of printing & typesetting industry.",
        interest: ["Football", "Rafting", "Nightout"],
        price: "20",
        commission: "15",
    },
    {
        id: 4,
        status: true,
        image: female4,
        gender: "Female",
        name: " Marco Alves",
        username: "marco.alves",
        email: "marco.alves@email.com",
        phone: "+1-985-999-625",
        registered: "22/09/2022",
        age: "19",
        location: "Xyz address",
        about:
            "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
        interest: ["Painting", "Writing", "Gaming"],
        price: "15",
        commission: "10",
    },
    {
        id: 5,
        status: false,
        image: female2,
        gender: "Female",
        name: "Mbe Tshinguta",
        username: "tshinguta",
        email: "mbe.tshinguta@email.com",
        phone: "+1-206-396-1973",
        registered: "22/09/2022",
        age: "31",
        location: "Abc address",
        about:
            "Lorem Ipsum is text of printing & typesetting industry of printing & typesetting industry.",
        interest: ["Shooting", "Baseball", "Boxing"],
        price: "10",
        commission: "15",
    },
    {
        id: 6,
        status: true,
        image: female3,
        gender: "Female",
        name: "Okasawara Karsumi",
        username: "okasawara.karsumi",
        email: "okasawara@email.com",
        phone: "+1-984-456-987",
        registered: "18/09/2022",
        age: "20",
        location: "Abc address",
        about:
            "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
        interest: ["Swimming", "Gaming", "Movies", "Surfing"],
        price: "25",
        commission: "13",
    },
];

export const paymentLog = [
    {
        id: 1,
        male: {
            id: 1,
            status: true,
            image: male1,
            gender: "Male",
            name: "John Doe",
            username: "john.doe",
            email: "john@email.com",
            phone: "+1-123-456-789",
            registered: "08/10/2022",
            age: "25",
            location: "Abc address",
            about:
                "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
            interest: ["Swimming", "Movies", "Nightout"],
        },
        female: {
            id: 1,
            status: true,
            image: female1,
            gender: "Female",
            name: "Ogasawara Katsumi",
            username: "ogasawara.katsumi",
            email: "ogasawara@email.com",
            phone: "+1-123-456-789",
            registered: "08/10/2022",
            age: "25",
            location: "Abc address",
            about:
                "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
            interest: ["Swimming", "Movies", "Nightout"],
            price: "20",
            commission: "10",
        },
        price: 20,
        commission: 10,
        femaleRevenue: 10,
        dateScheduled: '20/02/2022',
        datePaid: '24/02/2022',
        status: true
    },
    {
        id: 2,
        male: {
            id: 1,
            status: true,
            image: male1,
            gender: "Male",
            name: "John Doe",
            username: "john.doe",
            email: "john@email.com",
            phone: "+1-123-456-789",
            registered: "08/10/2022",
            age: "25",
            location: "Abc address",
            about:
                "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
            interest: ["Swimming", "Movies", "Nightout"],
        },
        female: {
            id: 2,
            status: true,
            image: female2,
            gender: "Female",
            name: "Stepan Assonov",
            username: "stepan.assonov",
            email: "stepan@email.com",
            phone: "+1-321-666-789",
            registered: "02/10/2022",
            age: "24",
            location: "Xyz address",
            about:
                "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing.",
            interest: ["Reading", "Movies", "Painting"],
            price: "30",
            commission: "20",
        },
        price: 40,
        commission: 15,
        femaleRevenue: 25,
        dateScheduled: '18/02/2022',
        datePaid: '19/02/2022',
        status: true
    },
    {
        id: 3,
        male: {
            id: 3,
            status: false,
            image: male3,
            gender: "Male",
            name: "Mike Roy",
            username: "mike.roy",
            email: "mikeroy@email.com",
            phone: "+1-525-864-125",
            registered: "26/09/2022",
            age: "27",
            location: "Abc street address",
            about:
                "simply dummy text of printing & typesetting industry of printing & typesetting industry.",
            interest: ["Football", "Rafting", "Nightout"],
        },
        female: {
            id: 5,
            status: false,
            image: female2,
            gender: "Female",
            name: "Mbe Tshinguta",
            username: "tshinguta",
            email: "mbe.tshinguta@email.com",
            phone: "+1-206-396-1973",
            registered: "22/09/2022",
            age: "31",
            location: "Abc address",
            about:
                "Lorem Ipsum is text of printing & typesetting industry of printing & typesetting industry.",
            interest: ["Shooting", "Baseball", "Boxing"],
            price: "10",
            commission: "15",
        },
        price: 10,
        commission: 2,
        femaleRevenue: 8,
        dateScheduled: '18/02/2022',
        datePaid: '18/02/2022',
        status: false
    },
    {
        id: 4,
        male: {
            id: 6,
            status: true,
            image: male3,
            gender: "Male",
            name: "James Doe",
            username: "james.doe",
            email: "james.doe@email.com",
            phone: "+1-984-456-987",
            registered: "18/09/2022",
            age: "20",
            location: "Abc address",
            about:
                "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
            interest: ["Swimming", "Gaming", "Movies", "Surfing"],
        },
        female: {
            id: 3,
            status: false,
            image: female3,
            gender: "Female",
            name: "Lucas Pacheco",
            username: "lucas.pacheco",
            email: "Lucas@email.com",
            phone: "+1-525-864-125",
            registered: "26/09/2022",
            age: "27",
            location: "Abc street address",
            about:
                "simply dummy text of printing & typesetting industry of printing & typesetting industry.",
            interest: ["Football", "Rafting", "Nightout"],
            price: "20",
            commission: "15",
        },
        price: 40,
        commission: 10,
        femaleRevenue: 30,
        dateScheduled: '12/02/2022',
        datePaid: '16/02/2022',
        status: true
    },
    {
        id: 5,
        male: {
            id: 2,
            status: true,
            image: male2,
            gender: "Male",
            name: "Mark Jason",
            username: "mark.jason",
            email: "mark@email.com",
            phone: "+1-321-666-789",
            registered: "02/10/2022",
            age: "24",
            location: "Xyz address",
            about:
                "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing.",
            interest: ["Reading", "Movies", "Painting"],
        },
        female: {
            id: 4,
            status: true,
            image: female4,
            gender: "Female",
            name: " Marco Alves",
            username: "marco.alves",
            email: "marco.alves@email.com",
            phone: "+1-985-999-625",
            registered: "22/09/2022",
            age: "19",
            location: "Xyz address",
            about:
                "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
            interest: ["Painting", "Writing", "Gaming"],
            price: "15",
            commission: "10",
        },
        price: 50,
        commission: 15,
        femaleRevenue: 35,
        dateScheduled: '11/02/2022',
        datePaid: '12/02/2022',
        status: true
    },
    {
        id: 6,
        male: {
            id: 5,
            status: false,
            image: male2,
            gender: "Male",
            name: "Isidro Haris",
            username: "isidro",
            email: "isidro@email.com",
            phone: "+1-206-396-1973",
            registered: "22/09/2022",
            age: "31",
            location: "Abc address",
            about:
                "Lorem Ipsum is text of printing & typesetting industry of printing & typesetting industry.",
            interest: ["Shooting", "Baseball", "Boxing"],
        },
        female: {
            id: 2,
            status: true,
            image: female2,
            gender: "Female",
            name: "Stepan Assonov",
            username: "stepan.assonov",
            email: "stepan@email.com",
            phone: "+1-321-666-789",
            registered: "02/10/2022",
            age: "24",
            location: "Xyz address",
            about:
                "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing.",
            interest: ["Reading", "Movies", "Painting"],
            price: "30",
            commission: "20",
        },
        price: 20,
        commission: 10,
        femaleRevenue: 10,
        dateScheduled: '06/02/2022',
        datePaid: '10/02/2022',
        status: false
    },
    {
        id: 7,
        male: {
            id: 4,
            status: true,
            image: male4,
            gender: "Male",
            name: "Will Byers",
            username: "byers.will",
            email: "will@email.com",
            phone: "+1-985-999-625",
            registered: "22/09/2022",
            age: "19",
            location: "Xyz address",
            about:
                "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
            interest: ["Painting", "Writing", "Gaming"],
        },
        female: {
            id: 4,
            status: true,
            image: female4,
            gender: "Female",
            name: " Marco Alves",
            username: "marco.alves",
            email: "marco.alves@email.com",
            phone: "+1-985-999-625",
            registered: "22/09/2022",
            age: "19",
            location: "Xyz address",
            about:
                "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
            interest: ["Painting", "Writing", "Gaming"],
            price: "15",
            commission: "10",
        },
        price: 25,
        commission: 5,
        femaleRevenue: 20,
        dateScheduled: '05/02/2022',
        datePaid: '06/02/2022',
        status: false
    },
    {
        id: 8,
        male: {
            id: 3,
            status: false,
            image: male3,
            gender: "Male",
            name: "Mike Roy",
            username: "mike.roy",
            email: "mikeroy@email.com",
            phone: "+1-525-864-125",
            registered: "26/09/2022",
            age: "27",
            location: "Abc street address",
            about:
                "simply dummy text of printing & typesetting industry of printing & typesetting industry.",
            interest: ["Football", "Rafting", "Nightout"],
        },
        female: {
            id: 6,
            status: true,
            image: female3,
            gender: "Female",
            name: "Okasawara Karsumi",
            username: "okasawara.karsumi",
            email: "okasawara@email.com",
            phone: "+1-984-456-987",
            registered: "18/09/2022",
            age: "20",
            location: "Abc address",
            about:
                "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
            interest: ["Swimming", "Gaming", "Movies", "Surfing"],
            price: "25",
            commission: "13",
        },
        price: 45,
        commission: 20,
        femaleRevenue: 25,
        dateScheduled: '20/02/2022',
        datePaid: '24/02/2022',
        status: true
    },
    {
        id: 9,
        male: {
            id: 3,
            status: false,
            image: male3,
            gender: "Male",
            name: "Mike Roy",
            username: "mike.roy",
            email: "mikeroy@email.com",
            phone: "+1-525-864-125",
            registered: "26/09/2022",
            age: "27",
            location: "Abc street address",
            about:
                "simply dummy text of printing & typesetting industry of printing & typesetting industry.",
            interest: ["Football", "Rafting", "Nightout"],
        },
        female: {
            id: 4,
            status: true,
            image: female4,
            gender: "Female",
            name: " Marco Alves",
            username: "marco.alves",
            email: "marco.alves@email.com",
            phone: "+1-985-999-625",
            registered: "22/09/2022",
            age: "19",
            location: "Xyz address",
            about:
                "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
            interest: ["Painting", "Writing", "Gaming"],
            price: "15",
            commission: "10",
        },
        price: 20,
        commission: 5,
        femaleRevenue: 15,
        dateScheduled: '20/02/2022',
        datePaid: '24/02/2022',
        status: false
    },
    {
        id: 10,
        male: {
            id: 5,
            status: false,
            image: male2,
            gender: "Male",
            name: "Isidro Haris",
            username: "isidro",
            email: "isidro@email.com",
            phone: "+1-206-396-1973",
            registered: "22/09/2022",
            age: "31",
            location: "Abc address",
            about:
                "Lorem Ipsum is text of printing & typesetting industry of printing & typesetting industry.",
            interest: ["Shooting", "Baseball", "Boxing"],
        },
        female: {
            id: 1,
            status: true,
            image: female1,
            gender: "Female",
            name: "Ogasawara Katsumi",
            username: "ogasawara.katsumi",
            email: "ogasawara@email.com",
            phone: "+1-123-456-789",
            registered: "08/10/2022",
            age: "25",
            location: "Abc address",
            about:
                "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
            interest: ["Swimming", "Movies", "Nightout"],
            price: "20",
            commission: "10",
        },
        price: 15,
        commission: 5,
        femaleRevenue: 10,
        dateScheduled: '20/02/2022',
        datePaid: '24/02/2022',
        status: false
    },
];

export const femaleApplicants = [
    {
        id: 1,
        image: female1,
        name: "Ogasawara Katsumi",
        username: "ogasawara.katsumi",
        email: "ogasawara@email.com",
        phone: "+1-123-456-789",
        age: "25",
        location: "Abc address",
        about:
            "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
        interest: ["Swimming", "Movies", "Nightout"],
        price: "20",
    },
    {
        id: 2,
        image: female2,
        name: "Stepan Assonov",
        username: "stepan.assonov",
        email: "stepan@email.com",
        phone: "+1-321-666-789",
        age: "24",
        location: "Xyz address",
        about:
            "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing.",
        interest: ["Reading", "Movies", "Painting"],
        price: "30",
    },
    {
        id: 3,
        image: female3,
        name: "Lucas Pacheco",
        username: "lucas.pacheco",
        email: "Lucas@email.com",
        phone: "+1-525-864-125",
        age: "27",
        location: "Abc street address",
        about:
            "simply dummy text of printing & typesetting industry of printing & typesetting industry.",
        interest: ["Football", "Rafting", "Nightout"],
        price: "20",
    },
    {
        id: 4,
        image: female4,
        name: " Marco Alves",
        username: "marco.alves",
        email: "marco.alves@email.com",
        phone: "+1-985-999-625",
        age: "19",
        location: "Xyz address",
        about:
            "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
        interest: ["Painting", "Writing", "Gaming"],
        price: "15",
    },
    {
        id: 5,
        image: female2,
        name: "Mbe Tshinguta",
        username: "tshinguta",
        email: "mbe.tshinguta@email.com",
        phone: "+1-206-396-1973",
        age: "31",
        location: "Abc address",
        about:
            "Lorem Ipsum is text of printing & typesetting industry of printing & typesetting industry.",
        interest: ["Shooting", "Baseball", "Boxing"],
        price: "10",
    },
    {
        id: 6,
        image: female3,
        name: "Okasawara Karsumi",
        username: "okasawara.karsumi",
        email: "okasawara@email.com",
        phone: "+1-984-456-987",
        registered: "18/09/2022",
        age: "20",
        location: "Abc address",
        about:
            "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
        interest: ["Swimming", "Gaming", "Movies", "Surfing"],
        price: "25",
    },
];

export const commissionLogs = [
    {
        id: 1,
        oldCommission: 15,
        newCommission: 20,
        updatedDate: "10/05/2022",
        effectiveDate: "15/05/2022"
    },
    {
        id: 2,
        oldCommission: 20,
        newCommission: 12,
        updatedDate: "05/02/2022",
        effectiveDate: "22/02/2022"
    },
    {
        id: 3,
        oldCommission: 12,
        newCommission: 15,
        updatedDate: "10/01/2022",
        effectiveDate: "20/01/2022"
    },
    {
        id: 4,
        oldCommission: 15,
        newCommission: 18,
        updatedDate: "19/11/2021",
        effectiveDate: "30/11/2021"
    },
    {
        id: 5,
        oldCommission: 18,
        newCommission: 12,
        updatedDate: "10/10/2021",
        effectiveDate: "20/10/2021"
    },
    {
        id: 6,
        oldCommission: 12,
        newCommission: 15,
        updatedDate: "16/07/2021",
        effectiveDate: "02/08/2021"
    },
];

export const feedbacks = [
    {
        id: 1,
        user: {
            id: 1,
            status: true,
            gender: "Male",
            image: male1,
            name: "John Doe",
            username: "john.doe",
            email: "john@email.com",
            phone: "+1-123-456-789",
            registered: "08/10/2022",
            age: "25",
            location: "Abc address",
            about:
                "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
            interest: ["Swimming", "Movies", "Nightout"],
        },
        subject: "Abc",
        message: "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
        date: "19/12/2022"
    },
    {
        id: 2,
        user: {
            id: 3,
            status: false,
            image: male3,
            gender: "Male",
            name: "Mike Roy",
            username: "mike.roy",
            email: "mikeroy@email.com",
            phone: "+1-525-864-125",
            registered: "26/09/2022",
            age: "27",
            location: "Abc street address",
            about:
                "simply dummy text of printing & typesetting industry of printing & typesetting industry.",
            interest: ["Football", "Rafting", "Nightout"],
        },
        subject: "Xyz",
        message: "Lorem Ipsum is text of printing & typesetting industry of printing & typesetting industry.",
        date: "01/12/2022"
    },
    {
        id: 3,
        user: {
            id: 4,
            status: true,
            image: female4,
            gender: "Female",
            name: " Marco Alves",
            username: "marco.alves",
            email: "marco.alves@email.com",
            phone: "+1-985-999-625",
            registered: "22/09/2022",
            age: "19",
            location: "Xyz address",
            about:
                "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
            interest: ["Painting", "Writing", "Gaming"],
            price: "15",
            commission: "10",
        },
        subject: "Abc Subject",
        message: "Lorem text of printing & typesetting industry of printing & typesetting industry.",
        date: "22/11/2022"
    },
    {
        id: 4,
        user: {
            id: 1,
            status: true,
            image: male1,
            gender: "Male",
            name: "John Doe",
            username: "john.doe",
            email: "john@email.com",
            phone: "+1-123-456-789",
            registered: "08/10/2022",
            age: "25",
            location: "Abc address",
            about:
                "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
            interest: ["Swimming", "Movies", "Nightout"],
        },
        subject: "Xyz Subject",
        message: "Lorem Ipsum is text of printing & typesetting industry of printing.",
        date: "11/11/2022"
    },
    {
        id: 5,
        user: {
            id: 2,
            status: true,
            image: female2,
            gender: "Female",
            name: "Stepan Assonov",
            username: "stepan.assonov",
            email: "stepan@email.com",
            phone: "+1-321-666-789",
            registered: "02/10/2022",
            age: "24",
            location: "Xyz address",
            about:
                "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing.",
            interest: ["Reading", "Movies", "Painting"],
            price: "30",
            commission: "20",
        },
        subject: "Abc 123 Subject",
        message: "Lorem Ipsum is text of printing & typesetting industry of printing & typesetting industry.",
        date: "29/09/2022"
    },
];

export const reports = [
    {
        id: 1,
        user: {
            id: 1,
            image: female1,
            name: "Ogasawara Katsumi",
            username: "ogasawara.katsumi",
            email: "ogasawara@email.com",
            phone: "+1-123-456-789",
            age: "25",
            location: "Abc address",
            about:
                "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
            interest: ["Swimming", "Movies", "Nightout"],
            price: "20",
        },
        reportedUser: {
            id: 2,
            status: true,
            image: male2,
            gender: "Male",
            name: "Mark Jason",
            username: "mark.jason",
            email: "mark@email.com",
            phone: "+1-321-666-789",
            registered: "02/10/2022",
            age: "24",
            location: "Xyz address",
            about:
                "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing.",
            interest: ["Reading", "Movies", "Painting"],
        },
        reason: "Lorem dummy text of printing & typesetting industry of printing & typesetting industry.",
        date: "16/12/2022",
    },
    {
        id: 2,
        user: {
            id: 4,
            status: true,
            image: female4,
            gender: "Female",
            name: " Marco Alves",
            username: "marco.alves",
            email: "marco.alves@email.com",
            phone: "+1-985-999-625",
            registered: "22/09/2022",
            age: "19",
            location: "Xyz address",
            about:
                "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
            interest: ["Painting", "Writing", "Gaming"],
            price: "15",
            commission: "10",
        },
        reportedUser: {
            id: 5,
            status: false,
            image: male2,
            gender: "Male",
            name: "Isidro Haris",
            username: "isidro",
            email: "isidro@email.com",
            phone: "+1-206-396-1973",
            registered: "22/09/2022",
            age: "31",
            location: "Abc address",
            about:
                "Lorem Ipsum is text of printing & typesetting industry of printing & typesetting industry.",
            interest: ["Shooting", "Baseball", "Boxing"],
        },
        reason: "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
        date: "15/12/2022",
    },
    {
        id: 3,
        user: {
            id: 1,
            image: female1,
            name: "Ogasawara Katsumi",
            username: "ogasawara.katsumi",
            email: "ogasawara@email.com",
            phone: "+1-123-456-789",
            age: "25",
            location: "Abc address",
            about:
                "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
            interest: ["Swimming", "Movies", "Nightout"],
            price: "20",
        },
        reportedUser: {
            id: 2,
            status: true,
            image: male2,
            gender: "Male",
            name: "Mark Jason",
            username: "mark.jason",
            email: "mark@email.com",
            phone: "+1-321-666-789",
            registered: "02/10/2022",
            age: "24",
            location: "Xyz address",
            about:
                "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing.",
            interest: ["Reading", "Movies", "Painting"],
        },
        reason: "Text of printing & typesetting industry of printing & typesetting industry.",
        date: "02/12/2022",
    },
    {
        id: 4,
        user: {
            id: 6,
            status: true,
            image: female3,
            gender: "Female",
            name: "Okasawara Karsumi",
            username: "okasawara.karsumi",
            email: "okasawara@email.com",
            phone: "+1-984-456-987",
            registered: "18/09/2022",
            age: "20",
            location: "Abc address",
            about:
                "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
            interest: ["Swimming", "Gaming", "Movies", "Surfing"],
            price: "25",
            commission: "13",
        },
        reportedUser: {
            id: 2,
            status: true,
            image: male2,
            gender: "Male",
            name: "Mark Jason",
            username: "mark.jason",
            email: "mark@email.com",
            phone: "+1-321-666-789",
            registered: "02/10/2022",
            age: "24",
            location: "Xyz address",
            about:
                "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing.",
            interest: ["Reading", "Movies", "Painting"],
        },
        reason: "Lorem Ipsum is simply dummy text of printing industry.",
        date: "22/11/2022",
    },
    {
        id: 5,
        user: {
            id: 1,
            status: true,
            image: female1,
            gender: "Female",
            name: "Ogasawara Katsumi",
            username: "ogasawara.katsumi",
            email: "ogasawara@email.com",
            phone: "+1-123-456-789",
            registered: "08/10/2022",
            age: "25",
            location: "Abc address",
            about:
                "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
            interest: ["Swimming", "Movies", "Nightout"],
            price: "20",
            commission: "10",
        },
        reportedUser: {
            id: 5,
            status: false,
            image: male2,
            gender: "Male",
            name: "Isidro Haris",
            username: "isidro",
            email: "isidro@email.com",
            phone: "+1-206-396-1973",
            registered: "22/09/2022",
            age: "31",
            location: "Abc address",
            about:
                "Lorem Ipsum is text of printing & typesetting industry of printing & typesetting industry.",
            interest: ["Shooting", "Baseball", "Boxing"],
        },
        reason: "Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
        date: "13/11/2022",
    },
    {
        id: 6,
        user: {
            id: 2,
            status: true,
            image: female2,
            gender: "Female",
            name: "Stepan Assonov",
            username: "stepan.assonov",
            email: "stepan@email.com",
            phone: "+1-321-666-789",
            registered: "02/10/2022",
            age: "24",
            location: "Xyz address",
            about:
                "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing.",
            interest: ["Reading", "Movies", "Painting"],
            price: "30",
            commission: "20",
        },
        reportedUser: {
            id: 2,
            status: true,
            image: male2,
            gender: "Male",
            name: "Mark Jason",
            username: "mark.jason",
            email: "mark@email.com",
            phone: "+1-321-666-789",
            registered: "02/10/2022",
            age: "24",
            location: "Xyz address",
            about:
                "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing.",
            interest: ["Reading", "Movies", "Painting"],
        },
        reason: "Lorem Ipsum is simply dummy text of printing & typesetting industry of printing & typesetting industry.",
        date: "06/11/2022",
    },
];

export const notifications = [
    {
        id: 1,
        userImage: male1,
        text:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        date: "Dec 19, 2022",
        time: "02:00 PM",
        unread: true,
    },
    {
        id: 2,
        userImage: female1,
        text:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry and typesetting industry.",
        date: "Dec 19, 2022",
        time: "01:40 PM",
        unread: true,
    },
    {
        id: 3,
        userImage: male2,
        text:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry, Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        date: "Dec 18, 2022",
        time: "09:13 PM",
        unread: false,
    },
    {
        id: 4,
        userImage: female2,
        text:
            "Lorem Ipsum is text of the printing and typesetting industry.",
        date: "Dec 18, 2022",
        time: "06:38 PM",
        unread: false,
    },
    {
        id: 5,
        userImage: male2,
        text:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. ",
        date: "Dec 18, 2022",
        time: "01:49 AM",
        unread: false,
    },
    {
        id: 6,
        userImage: male1,
        text:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        date: "Dec 18, 2022",
        time: "01:05 AM",
        unread: false,
    },
    {
        id: 7,
        userImage: female1,
        text:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        date: "Dec 17, 2022",
        time: "10:52 PM",
        unread: false,
    },
];
